import { useTranslation } from 'react-i18next'
import Button from '../../../components/ui/Button'
import type { TaskDecisionActions } from '../hooks/useTaskDecisionActions'
import { CLOSE_MAX_ITEMS } from '../types'

interface Props {
  actions: TaskDecisionActions
}

/**
 * <b>Kapat</b> ve <b>Yeniden Aç</b> butonları — Toplantı Yönetimi (105) ile Onaylarım'ın
 * Görev Kapatma sekmesinde (131) aynı görünür ve aynı kurala bağlıdır ({@code useTaskDecisionActions}).
 */
export default function TaskDecisionButtons({ actions }: Readonly<Props>) {
  const { t } = useTranslation()
  return (
    <>
      {actions.showCloseButton && (
        <Button
          label={t('meetingManagement.action.close')}
          icon="pi pi-check-square"
          disabled={!actions.canClose || actions.closePending}
          onClick={actions.onClose}
          // Pasif butonun SEBEBİ söylenir; sessizce pasif bir buton kullanıcıyı neyi
          // düzelteceğini bilmediği bir çıkmazda bırakır. `showOnDisabled` şart: PrimeReact
          // pasif butonda ipucunu varsayılan olarak hiç göstermez.
          tooltip={
            actions.tooManyToClose
              ? t('meetingManagement.close.tooMany', { max: CLOSE_MAX_ITEMS })
              : undefined
          }
          tooltipOptions={{ showOnDisabled: true, position: 'bottom' }}
        />
      )}
      {!actions.readOnly && (
        <Button
          variant="secondary"
          label={t('meetingManagement.action.reopen')}
          icon="pi pi-replay"
          disabled={!actions.canReopen}
          onClick={actions.openReopen}
        />
      )}
    </>
  )
}
